import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Business } from 'src/app/models/register-business';

@Component({
  selector: 'app-business-detail-header',
  templateUrl: './business-detail-header.component.html',
  styleUrls: ['./business-detail-header.component.scss']
})
export class BusinessDetailHeaderComponent implements OnInit, OnChanges {
  @Input() business: Business;
  @Input() reviews: any[] = [];
  @Output() highlightMarker = new EventEmitter<{ lat: number, lng: number }>();
  @Output() defaultMarker = new EventEmitter<{ lat: number, lng: number }>();
  isAllowEdit: boolean = false;
  showRatings: boolean = false;
  restaurantStatus: string = "";
  formGroup = new FormGroup({
    date: new FormControl("")
  });
  quickPhrase: string = '';

  constructor(
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.checkEditPermission();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['business'] && !changes['business'].firstChange) {
      this.checkEditPermission();
    }
    this.showRatings = false;
    setTimeout(() => {
      this.showRatings = true;
      if (this.reviews.length > 0) {
        const firstFive = this.reviews.slice(0, 5);
        const randomIndex = Math.floor(Math.random() * firstFive.length);
        const reviewData = firstFive[randomIndex];
        const review = reviewData.reviewText.split('!@#');
        this.quickPhrase = review && review[1] ? review[1] : "";
      }
    })
  }

  private checkEditPermission() {
    const branchId = localStorage.getItem('branchId');
    this.isAllowEdit = branchId === this.business?.branchId?.toString();
    this.cdr.detectChanges();
  }

  dropdownVisible = false;

  toggleDropdown(visible: boolean) {
    this.dropdownVisible = visible;
  }

  peopleSelect!: number;
  timeSelect!: number;
  peoples = [
    { id: 1, name: '2 people' },
    { id: 2, name: '4 people' },
    { id: 3, name: '8 people' },
  ];

  times = [
    { id: 1, name: '8:00 pm' },
    { id: 2, name: '9:00 pm' },
    { id: 3, name: '10:00 pm' },
  ];

  /**
   * Native share sheet where the browser has one (phones); otherwise copy the
   * link. The old version passed the router's relative path, did nothing at all
   * on desktop, and surfaced an unhandled AbortError whenever the sheet was
   * dismissed.
   */
  sharePage(): void {
    const url = window.location.href;
    const name = this.business?.name?.trim();
    const title = name ? `${name} · Hungery` : document.title;

    if (typeof navigator.share === 'function') {
      navigator.share({ title, text: name || undefined, url }).catch((error: any) => {
        if (error?.name !== 'AbortError') {
          this.copyLink(url);
        }
      });
      return;
    }
    this.copyLink(url);
  }

  private copyLink(url: string): void {
    const done = () => this.toastr.success('Link copied');
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(done, () => this.copyLinkFallback(url, done));
    } else {
      this.copyLinkFallback(url, done);
    }
  }

  private copyLinkFallback(url: string, done: () => void): void {
    const field = document.createElement('textarea');
    field.value = url;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch {
      copied = false;
    }
    document.body.removeChild(field);
    copied ? done() : window.prompt('Copy this link', url);
  }

  addHighlight(lat: number, lng: number) {
    this.highlightMarker.emit({ lat, lng });
  }

  removeHighlight(lat: number, lng: number) {
    this.defaultMarker.emit({ lat, lng });
  }
}
